/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListCRMMatchBypassResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'CRMMatchBypass',
        },
      },
    },
  }],
} as const;
